<template>
  <b-table :fields="fields" :items="items" :busy="loading" thStyle="style">
    <template v-slot:table-colgroup="scope">
      <col
        v-for="field in fields"
        :key="field.key"
        :style="rowStyle(field.key)"
      />
    </template>

    <template v-slot:cell(groupName)="data">
      <div>{{ data.item.title }}</div>
    </template>

    <template v-slot:cell(description)="data">
      <div>{{ data.item.description }}</div>
    </template>

    <template v-slot:cell(data)="data">
      <div v-if="data.item.type === 'limit'">
        <RuleLimit
          :params="data.item.args"
          :id="data.item.id"
          @change="changeItem(data.item)"
        />
      </div>

      <div v-if="data.item.type === 'thresh'">
        <RuleThresh
          :params="data.item.args"
          :id="data.item.id"
          @change="changeItem(data.item)"
        />
      </div>

      <div v-if="data.item.type === 'bounce'">
        <RuleBounce
          :params="data.item.args"
          :id="data.item.id"
          @change="changeItem(data.item)"
        />
      </div>
    </template>

    <template v-slot:cell(enabled)="data">
      <div class="text-center">
        <span class="switch switch-outline switch-icon switch-success">
          <label>
            <input
              type="checkbox"
              v-model="data.item.enabled"
              name="select"
              @change="changeItem(data.item)"
              :disabled="currentUser.id !== 1"
            />
            <span></span>
          </label>
        </span>
      </div>
    </template>

    <template v-slot:cell(delete)="data">
      <div class="text-center">
        <button
          class="btn btn-default btn-sm text-center"
          :disabled="currentUser.id !== 1 || !data.item.deletable"
          @click="deleteItem(data.item)"
        >
          <i
            class="flaticon2-rubbish-bin-delete-button icon-nm text-center pr-0"
          ></i>
        </button>
      </div>
    </template>
  </b-table>
</template>

<script>
import RuleLimit from "@/components/Domain/Rules/RuleLimit";
import RuleBounce from "@/components/Domain/Rules/RuleBounce";
import RuleThresh from "@/components/Domain/Rules/RuleThresh";
import { mapGetters } from "vuex";

export default {
  components: { RuleThresh, RuleBounce, RuleLimit },
  name: "AdsTable",
  props: {
    items: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  data() {
    return {
      fields: [
        { key: "groupName", label: "Name" },
        { key: "description", label: "Description" },
        { key: "data", label: "Data" },
        { key: "enabled", label: "" },
        { key: "delete", label: "" }
      ],
      style: {}
    };
  },
  methods: {
    rowStyle(key) {
      let style = { width: "10%" };
      switch (key) {
        case "groupName":
          style.width = "10%";
          break;

        case "description":
          style.width = "20%";
          break;

        case "data":
          style.width = "40%";
          break;
      }
      return style;
    },
    changeItem(obj) {
      this.$emit("change", obj);
    },
    deleteItem(obj) {
      if (this.currentUser.id !== 1) {
        return;
      }
      this.$emit("delete", obj);
    }
  }
};
</script>

<style scoped></style>
